export type BootPhase = { name: string; ms: number };

const phases: BootPhase[] = [];

/**
 * Startup phase timings, recorded by the web entry point and shown on the
 * Devices screen.
 *
 * The web build does real work before it can render anything — load the wasm
 * SQLite engine, restore the file store, register the icon font, then fetch
 * and parse the app chunk. On a desktop that is a few hundred milliseconds;
 * on an installed app on an older tablet it is evidently much worse, and
 * there is no console to read on a home-screen app. So the numbers are kept
 * here and displayed in the app instead of being logged.
 *
 * Native records nothing and the list stays empty, which the screen handles.
 */
export function recordBootPhase(name: string, ms: number): void {
  phases.push({ name, ms: Math.round(ms) });
}

export function bootTimings(): readonly BootPhase[] {
  return phases;
}

/** Time an async phase and record it under `name`. */
export async function timePhase<T>(name: string, run: () => Promise<T>): Promise<T> {
  const started = Date.now();
  try {
    return await run();
  } finally {
    recordBootPhase(name, Date.now() - started);
  }
}
